<template>
    <div class="ldc-select" v-click-outside="outside">
        <div class="ldc-input-select">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 443.52 443.52"
                version="1.1"
                viewBox="0 0 443.52 443.52"
                xmlSpace="preserve"
                @click="activeDropdown()">
                <path d="M143.492 221.863L336.226 29.129c6.663-6.664 6.663-17.468 0-24.132-6.665-6.662-17.468-6.662-24.132 0l-204.8 204.8c-6.662 6.664-6.662 17.468 0 24.132l204.8 204.8c6.78 6.548 17.584 6.36 24.132-.42 6.387-6.614 6.387-17.099 0-23.712L143.492 221.863z"></path>
            </svg>
            <input
                v-if="!multiple"
                type="text"
                autocomplete="off"
                :readonly="true"
                class="ldc-input"
                @click="clickActive()"
                @focus="activeDropdown()"
                @blur="outside()"
                v-model="model"
                :placeholder="placeholder"/>
            <div v-else class="ldc-input-multiple vg-scrollbar"
                @click="activeDropdown()">
                <div :placeholder="placeholder">
                    <span v-for="(item, index) in model" :key="index"
                        class="one-multiple fs-14px text-truncate">
                        {{item}},
                    </span>
                </div>
            </div>
            <div class="ldc-select-dropdown">
                <div class="ldc-select-scrollbar vg-scrollbar">
                    <ul>
                        <slot/>
                        <li class="not-search" v-if="options.length == 0">Không có dữu liệu</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: 'placeholder'
        },
        value: {
            default: '',
        },
        filterable: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false
        },
        actionKeyBoard: {
            type: Boolean,
            default: true,
        },
    },
    updated() {
        this.getValue();
    },
    data(){
        return {
            model: '',
            data: '',
            active: false,
            setHeigth: false,
            options: [],
            change: null,
            indexHover: '',
        }
    },
    watch: {
        data: {
            handler(val){
                this.$emit('input', val);
                this.getValue();
            },
            deep: true,
        },
        value: {
            handler(val){
                this.data = val;
            },
            deep: true,
        },
        options: {
            handler(val){
                this.getValue();
            },
            deep: true,
        },
        active(val){
            if(this.$detect == 'web' && this.actionKeyBoard){
                this.$emit('dataActive', val);
                if(val){
                    window.addEventListener('keydown', this.keyCodeGlobal);
                    this.getValue();
                }else{
                    window.removeEventListener('keydown', this.keyCodeGlobal);
                }
            }
        },
        indexHover(val){
            if(!this.$children) return;
            this.$children.map((item, index) => {
                if(item.$options && item.$options._componentTag === 'ldc-option' &&
                    item.$props.label != undefined && item.$props.value != undefined){
                    if(index === val){
                        item.$data.index = item.value;
                    }else{
                        item.$data.index = '';
                    }
                }
            })
        }
    },
    created() {
        if(this.multiple){
            this.data = [];
            this.model = [];
        }
        let listeners = this.$listeners
        if(typeof(listeners.change) == 'function'){
            this.change = listeners.change;
        }
        this.data = this.value;
        this.getValue();
    },
    methods: {
        clickActive(){
            // console.log(this.active)
            // if(this.active){
            //     // this.activeDropdown();
            // }
        },
        keyCodeGlobal(e){
            if(e.keyCode == 40){
                // ArrowDown
                if(this.options.length == 0) return;
                if(this.indexHover === '' || this.indexHover == this.options.length - 1){
                    this.indexHover = 0;
                }else{
                    this.indexHover += 1;
                }
                e.preventDefault();
            }else if(e.keyCode == 38){
                // ArrowUp
                if(this.options.length == 0) return;
                if(this.indexHover === '' || this.indexHover == 0){
                    this.indexHover = this.options.length - 1;
                }else{
                    this.indexHover -= 1;
                }
                e.preventDefault();
            }else if(e.keyCode == 13){
                // Enter
                if(this.options.length == 0 || this.indexHover === '') return;
                if(this.multiple){
                    if(this.data.includes(this.options[this.indexHover].value) == true){
                        this.data.map((item, index) => {
                            if(item === this.options[this.indexHover].value){
                                this.data.splice(index, 1);
                            }
                        })
                    }else{
                        this.data.push(this.options[this.indexHover].value);
                    }
                }else{
                    this.data = this.options[this.indexHover].value;
                }
                this.getValue();
                this.change();
                this.activeDropdown();
            }else if(e.keyCode == 27){
                // Escape
                this.$el.querySelector('.ldc-input').blur();
                if(this.active){
                    this.activeDropdown();
                }
            }
        },
        outside(e){
            if(!e || (e && this.$el.contains(e.target)) || !this.active) return;
            let dropdown = this.$el.querySelector('.ldc-select-dropdown');
            let svg = this.$el.querySelector('.ldc-input-select svg');
            let input = this.$el.querySelector('.ldc-input-select');
            dropdown.style.height = '0px';
            dropdown.style.border = 'none';
            svg.style.transform= 'rotate(-90deg)';
            input.classList.remove('is-focus');
            this.active = false;
        },
        activeDropdown(){
            if(this.multiple && this.data.length > 0 && this.active) return;
            let dropdown = this.$el.querySelector('.ldc-select-dropdown');
            let svg = this.$el.querySelector('.ldc-input-select svg');
            let input = this.$el.querySelector('.ldc-input-select');
            if(!this.active){
                let height = dropdown.querySelector('.ldc-select-scrollbar').offsetHeight;
                dropdown.style.height = height + 'px';
                dropdown.style.border = '1px solid #e4e7ed';
                svg.style.transform= 'rotate(90deg)';
                input.classList.add('is-focus');
            }else{
                dropdown.style.height = '0px';
                dropdown.style.border = 'none';
                svg.style.transform= 'rotate(-90deg)';
                input.classList.remove('is-focus');
            }
            this.active = !this.active;
        },
        getValue(){
            let check = true;
            if(!this.$children) return;
            this.$children.map((item, index) => {
                if(item.$options && item.$options._componentTag === 'ldc-option' &&
                    item.$props.label != undefined && item.$props.value != undefined){
                    if(!this.multiple){
                        if(this.data === item.$props.value){
                            if(this.$detect == 'web' && this.actionKeyBoard){
                                this.indexHover = index;
                            }
                            this.model = item.$props.label;
                            item.$data.model = this.data;
                            item.$data.labelModel = this.model;
                            check = false;
                            this.index = index;
                        }else{
                            item.$data.model = '';
                            item.$data.labelModel = '';
                        }
                    }else{
                        if(this.data.includes(item.$props.value) == true){
                            if(!this.model.includes(item.$props.label)){
                                this.model.push(item.$props.label);
                            }
                            item.$data.model = item.$props.value;
                            item.$data.labelModel = item.$props.label;
                        }else{
                            item.$data.model = '';
                            item.$data.labelModel = '';
                        }
                    }
                }
            })
            if(check && !this.multiple){
                this.model = '';
            }
        },
        removeItem(index){
            this.data.splice(index, 1);
            this.model.splice(index, 1);
            this.active = true;
        }
    }
}
</script>